export interface ContactSupportJson {
  reason: string;
  subject: string;
  description: string;
  files: File[];
  company_id: number;
  company_name: string;
  user_id: number;
}

export class ContactSupport {
  constructor(
    public reason: string,
    public subject: string,
    public description: string,
    public files: File[],
    public companyId: number,
    public companyName: string,
    public userId: number
  ) {}

  static toJson(model: ContactSupport): ContactSupportJson {
    return {
      reason: model.reason,
      subject: model.subject,
      description: model.description,
      files: model.files,
      company_id: model.companyId ?? undefined,
      company_name: model.companyName ?? undefined,
      user_id: model.userId ?? undefined
    };
  }
}
